import SEOHead from '../components/SEOHead';
import { COMPLIANCE_DISCLOSURE_TEXT, LEGAL_CONSENT_DOCUMENT_PATH } from '../constants/site';

export default function DisclosurePage() {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="disclosure-page">
      <SEOHead
        title="Disclosure | Flash Funding"
        description="Understand how Flash Funding is remunerated and how referral and commission arrangements operate."
        canonical="/disclosure"
      />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="disclosure-main-section">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">Disclosure</h1>
        <div className="rounded-2xl border border-white/10 bg-navy-800/70 p-6 space-y-4 text-sm text-white/75 leading-relaxed" data-testid="disclosure-content">
          <p>
            Flash Funding may receive commission income and referral income from lenders or approved referral partners when a facility settles.
            The structure and amount vary by product, lender policy, and deal profile.
          </p>
          <p>
            Commission model details are provided in writing before formal application.
          </p>
          <p>
            Upfront commissions, where applicable, are disclosed as part of your quote and recommendation process.
          </p>
          <p>
            Ongoing or trail commission arrangements vary by lender and product and are disclosed before proceeding.
          </p>
          <p>
            Referral fee arrangements, where applicable, are disclosed before your information is shared.
          </p>
          <p>
            If you require more detail for your specific scenario, request a written disclosure before proceeding to formal application.
          </p>
          <p data-testid="disclosure-compliance-line">
            {COMPLIANCE_DISCLOSURE_TEXT}
          </p>
          <p>
            Please review our combined Credit Guide &amp; Privacy document:{' '}
            <a href={LEGAL_CONSENT_DOCUMENT_PATH} target="_blank" rel="noopener noreferrer" className="text-purple-300 underline" data-testid="disclosure-credit-guide-link">
              Credit Guide &amp; Privacy (PDF)
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
